import React from 'react'
import styles from './styles.module.css'

const PlaceholderShadow = () => {
  return <div className={styles.animationShadow} />
}

export default PlaceholderShadow
